import axios from 'axios';
import CryptoJS from 'crypto-js';

const API_URL = process.env.NEXT_API_URL || 'https://app.getgeek.ai/getgeek_backend';
const PLAN_AND_SUB_KEY = process.env.NEXT_PUBLIC_PLAN_AND_SUBCRIPTION_SERVICE_KEY;

const secretCryptoKeys = {
  plan_subscription_key: PLAN_AND_SUB_KEY
};

/**
 * Request Wrapper with default success/error actions
 */
const request = async (options) => {
  const token = process.env.NEXT_RP_API_AUTH_TOKEN;

  const client = axios.create({
    baseURL: API_URL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const onSuccess = (response) => {
    return response?.data;
  };

  const onError = (error) => {
    console.error('Request error:', error);
    return Promise.reject(error.response ? error.response.data : error);
  };

  return client(options).then(onSuccess).catch(onError);
};

/**
 * Decode encrypted data
 */
export const decodedData = (value, key) => {
  try {
    const decryptedValue = CryptoJS.AES.decrypt(
      value,
      secretCryptoKeys[key]
    ).toString(CryptoJS.enc.Utf8);
    const decodeValue = JSON?.parse(decryptedValue);
    return decodeValue;
  } catch (error) {
    console.error('Decode error:', error);
    return null;
  }
};

export default request;
